export default "__VITE_ASSET__DMShyulQ__"